module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-close-down@1x.png?0.0.53";